import {Api} from '../../Api.js'

const RESOURCE = 'person'

export default {
    resource: RESOURCE,
    export() {

        return window.axios({
            url: window.axios.defaults.baseURL + '/' + this.resource + '/export',
            method: 'GET',
            responseType: 'blob', // important
        });

    },
    query(query) {
        return Api().get(this.resource + (query ? query : ''))
    },
    get(id) {
        return Api().get(this.resource + '/' + id)
    },
    create(data) {
        return Api().post(this.resource, data)
    },
    update(id, data) {
        return Api().put(this.resource + '/' + id, data)
    },
    delete(id) {
        return Api().delete(this.resource + '/' + id)
    }
}


// WEBPACK FOOTER //
// ./src/modules/person/PersonService.js